import { defineMessages } from 'react-intl';

export const operatorsMessages = defineMessages({
  // error
  createOperatorError: {
    id: 'messages.oepratorMessages.createOperatorError',
    defaultMessage: 'Could not create operator:',
  },

  // success
  createOperatorSuccess: {
    id: 'messages.operatorMessages.createOperatorSuccess',
    defaultMessage: 'operator has been created successfully!',
  },

  // error
  editOperatorError: {
    id: 'messages.oepratorMessages.editOperatorError',
    defaultMessage: 'Could not edit operator:',
  },

  // success
  editOperatorSuccess: {
    id: 'messages.operatorMessages.editOperatorSuccess',
    defaultMessage: 'operator has been edited successfully!',
  },
});
